export const enum ISSUER_ENUM {
  PROD_DOMAIN = 'www.delta.com',
  STAGE = 'stg',
  PROD = 'prd'
}
